import { render, staticRenderFns } from "./TsAcademicYearFilter.vue?vue&type=template&id=095be83e&scoped=true&"
import script from "./TsAcademicYearFilter.vue?vue&type=script&lang=js&"
export * from "./TsAcademicYearFilter.vue?vue&type=script&lang=js&"
import style0 from "./TsAcademicYearFilter.vue?vue&type=style&index=0&id=095be83e&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095be83e",
  null
  
)

export default component.exports